// Colocated Driver.js tour for the Set Transaction PIN page. Fires the
// first time a user reaches this page without a PIN, so it lands the moment
// they arrive from the Security walkthrough handoff on the FAQ page. Kept
// to a single step because the page itself is a single form with an obvious
// primary action; the tour only exists to name the rules the form's helper
// paragraph already reads.

export const SET_TRANSACTION_PIN_TOUR_ID = 'set-transaction-pin-v1';

export const buildSetTransactionPinTourSteps = () => [
    {
        element: '[data-tour="set-transaction-pin-card"]',
        title: 'Set your transaction PIN',
        description: 'Pick six digits you can remember. Avoid obvious runs like 123456, repeats like 111111, or anything derived from your phone number. You will use this PIN to authorise every money movement, so treat it the same way you treat a bank PIN.',
        side: 'bottom',
        align: 'center',
    },
];
